$(function () {
  function preventOffscreenMenu(index, elem) {
    // Reset element
    $(this).css('left', '');

    // We need to display the element once to get correct values
    $(this).add($(this).parents('ul.dropdown-menu')).css('display', 'block');
    var offset = $(this).offset().left;
    var outerWidth = $(this).outerWidth();
    $(this).add($(this).parents('ul.dropdown-menu')).css('display', '');

    // Check if it exceeds the screen and apply positioning
    if ((offset + outerWidth) > $(window).width()) {
      var remainingSizeToScreenEdge = $(window).width() - offset - 10;

      if (remainingSizeToScreenEdge < 0) {
        remainingSizeToScreenEdge = 0;
      }

      $(this).css('left', remainingSizeToScreenEdge);
    }
  }

  $(window).on('resize', function () {
    $('.small-menu-wrapper ul.dropdown-menu').each(preventOffscreenMenu);
  }).trigger('resize');
})
